import RIOSelect from '@rio-cloud/rio-uikit/Select';

import type { SelectOption } from './types';

export type { SelectOption };

interface SingleSelectProps {
    options: SelectOption[];
    onChange: (id: string) => void;
    id?: string;
    name?: string;
    placeholder?: string;
    /** Currently selected option id. */
    value?: string | null;
    hasError?: boolean;
    className?: string;
    btnClassName?: string;
    dropdownClassName?: string;
}

/**
 * Thin wrapper around RIO UI Kit's Select for the common single-value case.
 * Encapsulates the array<->single-id conversion so consumers work with a plain
 * option id instead of RIO's multi-select value/onChange shape.
 */
const SingleSelect = ({
    options,
    onChange,
    id,
    name,
    placeholder,
    value,
    hasError,
    className,
    btnClassName,
    dropdownClassName,
}: SingleSelectProps) => (
    <RIOSelect
        id={id}
        name={name}
        placeholder={placeholder}
        options={options}
        value={value ? [value] : []}
        onChange={option => onChange(option?.id ?? '')}
        hasError={hasError}
        className={className}
        btnClassName={btnClassName}
        dropdownClassName={dropdownClassName}
    />
);

export default SingleSelect;
